import React, { Component } from "react"
import PropTypes from "prop-types"
import { Menu } from "semantic-ui-react"
import { Link } from "react-router-dom"
import { navigationPaths } from "../../constants/paths"
import { gaJSON, trackFirebaseAnalytics } from "../../helpers/googleAnalyticsHelpers"
import { transformString } from "../../utilities/TireFilterHelpers"

class NavItem extends Component {
  static propTypes = {
    content: PropTypes.node.isRequired,
    linkPath: PropTypes.string.isRequired,
    active: PropTypes.bool,
    currentUser: PropTypes.object
  }

  static defaultProps = {
    active: false
  }

  render() {
    const { linkPath, content, active, badge, badgeStyle, currentUser } = this.props
    return (
      <Link to={linkPath} style={{ position: "relative" }}>
        {badge && <span style={badgeStyle}>{badge}</span>}
        <Menu.Item
          active={active}
          onClick={() => {
            if (linkPath === navigationPaths.tiresSelectVehicle()) {
              trackFirebaseAnalytics({
                event: gaJSON.tires_entry_clicked,
                params: {
                  entry_point: "tires_nav",
                  user_role: currentUser.roles.toString()
                }
              })
            }
          }}
        >
          {content}
        </Menu.Item>
      </Link>
    )
  }
} // class NavItem

export default NavItem
